import { CSSProperties } from 'react';
import { LockKeyhole } from 'lucide-react';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { Button, Card, Typography } from '../ui';
import styles from './BriefSlot.module.css';
import { upgradeHref } from '../../../lib/upgrade-origin';

// Mobile-card rendering of the credit-paused "your agents have updates waiting" brief state — the flat
// desktop content (`UpgradeBrief`) presented as a floating `Card`, matching `MobileActivateBrief`'s
// shape: a lock eyebrow ("Morning Meetings paused"), the plain heavy-sans headline, body copy, and the
// standard credits upgrade CTA. Phone-sized headline (32) like its sibling. Mirrors the native
// `BriefUpgradeCard`s.

// Headline — the heavy display sans, plain (no serif accent run): Archivo SemiBold 32/32.
const HEADLINE_SANS: CSSProperties = {
  fontFamily: 'var(--brand-font-display)',
  fontSize: 32,
  fontWeight: 'var(--sym-weight-semibold)',
  lineHeight: '32px',
  letterSpacing: '-0.96px',
  color: 'rgb(var(--ink-rgb))',
};

// Body copy — same pinned metrics as MobileActivateBrief's body (Wix Madefor Text 14/20, -0.42px,
// black): the `.sym-*` type variants out-specify the module class and carry 18px / -0.02em.
const BODY_TEXT: CSSProperties = {
  fontFamily: 'var(--brand-font-ui)',
  fontSize: 14,
  fontWeight: 'var(--sym-weight-semibold)',
  lineHeight: '20px',
  letterSpacing: '-0.42px',
  color: 'rgb(var(--ink-rgb))',
  fontFeatureSettings: "'dlig' on",
};

export function MobileUpgradeBrief() {
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();

  return (
    <Card component="section" style={{ textAlign: 'start' }} aria-labelledby="brief-upgrade-title">
      <p className={styles.eyebrow}>
        <LockKeyhole size={16} aria-hidden />
        <Typography variant="h4" color="strong" component="span">
          {t('brief.upgrade.eyebrow')}
        </Typography>
      </p>
      <div id="brief-upgrade-title" className={styles.mobileHeadline} style={HEADLINE_SANS}>
        {t('brief.upgrade.title')}
      </div>
      <p className={styles.mobileBody} style={BODY_TEXT}>
        {t('brief.upgrade.body')}
      </p>
      <div className={styles.mobileCta}>
        <Button
          href={upgradeHref('brief_upgrade')}
          onClick={() => {
            logPageClickBi({ page_name: 'home', button_name: 'brief_upgrade' });
          }}
        >
          {t('brief.upgrade.cta')}
        </Button>
      </div>
    </Card>
  );
}
